/**
 * @file Task board adapter.
 */

import { renderTaskKanban } from "../../shared/board/parentBoardKanban.js";
import { renderTaskTable } from "../../shared/board/parentBoardTable.js";
import { createParentBoardAdapter } from "../../shared/board/parentBoardAdapterFactory.js";

export const taskBoardAdapter = createParentBoardAdapter({
  adapterKey: "task",
  viewKey: "tasks",
  renderers: {
    table: renderTaskTable,
    kanban: renderTaskKanban,
  },
});
